import axios from "axios";
import SnackbarService from "../../../app/components/theme/Snackbar/service";
import BlockUIService from "../../../app/components/theme/BlockUI/service";

const { REACT_APP_API_LOCATION } = process.env;

const ADMIN_LIST = `${REACT_APP_API_LOCATION}/Admin/Annoucements`;

const mapGetResponse = ({ data }: any) =>
  data.map((annoucement: any) => ({
    id: annoucement.id,
    title: annoucement.title,
    startDate: annoucement.startDate,
    endDate: annoucement.endDate,
    membershipType:
      annoucement.membershipType === 0
        ? "Basica, PRO, PRO MAX"
        : annoucement.membershipType === 1
        ? "Basica"
        : annoucement.membershipType === 2
        ? "PRO"
        : "PRO Max",
    body: annoucement.body,
    views_count : annoucement.views.length,
  }));

const api = {
  load: async (textSearch: string, pageNumber: number, pageSize: number) => {
    BlockUIService.show();
    try {
      const params = { pageNumber, pageSize } as {
        textSearch: string;
        pageNumber: number;
        pageSize: number;
      };
      if (textSearch) params.textSearch = textSearch;
      const response = await axios.get(ADMIN_LIST, { params });
      return {
        entities: mapGetResponse(response.data),
        pagination: response.data.metadata,
      };
    } catch (e: any) {
      console.error(e);
      const message = e?.response?.data?.error?.message;
      await SnackbarService.show(message || "Ha ocurrido un problema", "error");
      return {
        entities: [],
        pagination: {
          total: 0,
          pages: 1,
          pageNumber: 1,
        },
      };
    } finally {
      BlockUIService.hide();
    }
  },
  delete: async (annoucementId: string) => {
    BlockUIService.show();
    try {
      await axios.delete(`${ADMIN_LIST}/${annoucementId}`);
      await SnackbarService.show(
        "El anuncio se eliminó correctamente",
        "success"
      );
    } catch (e: any) {
      const message = e?.response?.data?.error?.message;
      await SnackbarService.show(message || "Ha ocurrido un problema", "error");
      throw e;
    } finally {
      BlockUIService.hide();
    }
  },
};

export default api;
